export const VAUTO_APPRAISALS_REQUEST = 'VAUTO_APPRAISALS_REQUEST';
export const VAUTO_APPRAISALS_SUCCESS = 'VAUTO_APPRAISALS_SUCCESS';
export const VAUTO_APPRAISALS_FAILURE = 'VAUTO_APPRAISALS_FAILURE';

export const VAUTO_APPRAISAL_LAUNCHED = 'VAUTO_APPRAISAL_LAUNCHED';
export const VAUTO_APPRAISAL_SLIDEOUT_LOADED = 'VAUTO_APPRAISAL_SLIDEOUT_LOADED';
export const VAUTO_APPRAISAL_MESSAGE_RECEIVED = 'VAUTO_APPRAISAL_MESSAGE_RECEIVED';
export const VAUTO_APPRAISAL_MESSAGE_REJECTED = 'VAUTO_APPRAISAL_MESSAGE_REJECTED';
